/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import Failed from '../../assets/images/failed.png';

function PaymentFailed() {
  return (
    <Box className="invoiceAppLoginWrap">
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={5} md={5}>
          <Box className="loginRightForm">
            <Box
              className="loginFormWrap"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
              }}
            >
              <Box className="logninInner">
                <img alt="Payment Failed" src={Failed} />
                <Typography variant="h3" gutterBottom component="" mb={2}>
                  Sorry, Payment Failed
                </Typography>
                <Typography
                  variant="body1"
                  align="center"
                  className="subtitle"
                  sx={{ fontSize: '16px !important' }}
                  component="p"
                  mb={2}
                >
                  Your payment has failed. Please review the payment details and try again.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PaymentFailed;
